import { render, staticRenderFns } from "./CpMallEduSell.vue?vue&type=template&id=2fe78932&scoped=true&"
import script from "./CpMallEduSell.vue?vue&type=script&lang=js&"
export * from "./CpMallEduSell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe78932",
  null
  
)

export default component.exports